import {
  Bitmap,
  ButtonBase,
  Container,
  delayedCall,
  dispatcher,
  Graphics,
  IEvent,
  ingenuity,
  killDelayedCall,
  Linear,
  Meter,
  SpineBase,
} from "@quest/base-core";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { ITween } from "@quest/adapter-interface";
import { Exponential } from "@quest/base-core";
import { AudioControllerBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther";
import { SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { CollectionModel } from "./CollectionModel";
import { CollectionScreenView } from "./CollectionScreenView";

export class CollectionScreenController {
  private view: CollectionScreenView;
  private model: CollectionModel;
  private collectionMainContainer: Container;
  private collectionContainer_152: Container;
  private collectionContainer_151: Container;
  private CollectionPanelgameLogo: Bitmap;
  private progress152: any[];
  private progress151: any[];


  constructor(view: CollectionScreenView, model: CollectionModel) {
    this.view = view;
    this.model = model;
    this.init();
  }

  private init(): void {
    this.initializeElements();
    this.subscribeEvents();
    this.assignListeners();
    this.handleMasks();
  }

  private initializeElements(): void {
    this.collectionMainContainer = this.view.getContainerByID("collectionMainContainer");
    this.CollectionPanelgameLogo = this.view.getImageById("CollectionPanelgameLogo");
    this.collectionContainer_151 = this.view.getContainerByID("collectionContainer_151");
    this.collectionContainer_152 = this.view.getContainerByID("collectionContainer_152");
  }
  //Assigns listerners to the buttons on collection screen.
  private assignListeners(): void {
    this.view.getButtonById("backBtn_152").on(ButtonBase.UP, this.hideCollectionScreen, this);
    this.view.getButtonById("backBtn_151").on(ButtonBase.UP, this.hideCollectionScreen, this);
    this.view.getButtonById("nextPageBtn").on(ButtonBase.UP, this.onNextPagePressed, this);
    this.view.getButtonById("previousPageBtn").on(ButtonBase.UP, this.onPrevPagePressed, this);
  }
  private subscribeEvents(): void {
    this.unsubscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_COLLECTION_PAYOUT, this.updateCollectionPayout, this);
    dispatcher.on(eventDispatchers.SHOW_BUBBLE_GLOW, this.onShowBubbleGlow, this);
    dispatcher.on(eventDispatchers.SHOW_COLLECTION_SCREEN, this.onShowCollectionScreen, this);
    dispatcher.on(eventDispatchers.REVEAL_COLLECTION_AFTER_HNR, this.onRevealCollectionAfterHnR, this);
    dispatcher.on(eventDispatchers.CHECK_FOR_PROGRESS, this.updateMasksFromData, this);
    dispatcher.on(eventDispatchers.HIDE_COLLECTION_SCREEN, this.tweenAwayPanel, this);
    dispatcher.on(eventDispatchers.RESET_PROGRESS_AFTER_WIN, this.onResetProgressAfterWin, this);
    dispatcher.on(eventDispatchers.ADD_COLLECTION_ON_TOP, this.view.addViewToTop, this.view);
  }
  private unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.UPDATE_COLLECTION_PAYOUT, this.updateCollectionPayout, this);
    dispatcher.off(eventDispatchers.SHOW_BUBBLE_GLOW, this.onShowBubbleGlow, this);
    dispatcher.off(eventDispatchers.SHOW_COLLECTION_SCREEN, this.onShowCollectionScreen, this);
    dispatcher.off(eventDispatchers.REVEAL_COLLECTION_AFTER_HNR, this.onRevealCollectionAfterHnR, this);
    dispatcher.off(eventDispatchers.CHECK_FOR_PROGRESS, this.updateMasksFromData, this);
    dispatcher.off(eventDispatchers.HIDE_COLLECTION_SCREEN, this.tweenAwayPanel, this);
    dispatcher.off(eventDispatchers.RESET_PROGRESS_AFTER_WIN, this.onResetProgressAfterWin, this);
    dispatcher.off(eventDispatchers.ADD_COLLECTION_ON_TOP, this.view.addViewToTop, this.view);
  }

  //Responsible for updating the payout amount for every collection every time the collection panel is opened.
  private updateCollectionPayout(evt: IEvent): void {
    this.updateWinAmount(gameConstants.RED_COLLECTION_ID);
    this.updateWinAmount(gameConstants.GREEN_COLLECTION_ID);
  }
  
  //Updates the payout amount for each individual collection.
  private updateWinAmount(collectionId: number): void {
    gameConstants.COLLECTION_LEVELS_GAME.forEach((id: number, index: number) => {
      const winMeterId = `${id}WinAmt_${collectionId}`;
      const winMeter = this.view.getMeterById(winMeterId);
      const winAmount = this.model.getCollectionWinAmount(collectionId, gameConstants.COLLECTION_LEVELS_SERVER_ID[index]);
      winMeter.setCurrencyFormattedValue(winAmount.toString());

      const meterContainer = `${id}PayoutContainer_${collectionId}`;
      if (winAmount > 0) {
        this.view.getContainerByID(meterContainer).visible = true;
      } else {
        this.view.getContainerByID(meterContainer).visible = false;
      }
    });
  }

  //Sets the flow for the appearance of collection screen.
  private onShowCollectionScreen(): void {
    this.tweenDownPanel();
  }

  //Tweens the collection Panel down the screen when collection button is clicked or bonus has ended.
  private tweenDownPanel(collectionId?: number): void {
    if (collectionId) {
      this.showCollectionBasedOnBait(collectionId);
    }
    this.collectionMainContainer.visible = true;
    this.CollectionPanelgameLogo.visible = true;
    (ingenuity.deviceEnv.getOrientation() !== "portrait") && this, this.view.getContainerByID("logoContainer").visible = true;
    this.collectionMainContainer.y = -2000;
    const dropDownTween: ITween = ingenuity.currentGame.add.tween(this.collectionMainContainer);
    dropDownTween.to({ y: -60 }, 600, Exponential.Out);
    dropDownTween.start();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.COLLECTION_BG);
    this.updateMasksFromData();
    if (!ingenuity.configData.isCollectionAfterHnR) {
      this.handleCollectionButtonsInput(gameConstants.COLLECTION_BUTTONS_ENABLE);
    }
    dropDownTween.onComplete.addOnce(() => {
      if (ingenuity.configData.isCollectionAfterHnR) {
        this.animateAllProgressBars((ingenuity.parserModel as GameParserModel).getTriggeredBait());
        this.handleCollectionButtonsInput(gameConstants.COLLECTION_BUTTONS_DISABLE);
        this.updateWinMeterOnCollection((ingenuity.parserModel as GameParserModel).getTriggeredBait())
      }
      dropDownTween.stop();
      ingenuity.currentGame.tweens.remove(dropDownTween);
    });
  }
  //Updates the payout amount for each individual collection.
  private updateWinMeterOnCollection(collectionId: number): void {
    gameConstants.COLLECTION_LEVELS_GAME.forEach((id: number, index: number) => {
      const winMeterId = `${id}WinAmt_${collectionId}`;
      const winMeter = this.view.getMeterById(winMeterId);
      const winAmount = this.model.getCollectionUpdatedWinAmount(collectionId, gameConstants.COLLECTION_LEVELS_SERVER_ID[index]);
      const meterContainer = `${id}PayoutContainer_${collectionId}`;
      if (winAmount > 0) {
        this.view.getContainerByID(meterContainer).visible = true;
      } else {
        this.view.getContainerByID(meterContainer).visible = false;
      }
      winMeter.startTick(winAmount, true, false, 0.7, true, () => {
        //
      });
    });
  }
  //Determines what collection is shown by default based on the triggered bait.
  private showCollectionBasedOnBait(collectionId: number): void {
    switch (collectionId) {
      case gameConstants.GREEN_COLLECTION_ID:
        this.collectionContainer_152.visible = true;
        this.collectionContainer_151.visible = false;
        break;
      case gameConstants.RED_COLLECTION_ID:
        this.collectionContainer_151.visible = true;
        this.collectionContainer_152.visible = false;
        break;
      default:
        this.collectionContainer_152.visible = true;
        this.collectionContainer_151.visible = false;
        break;
    }
  }

  //Sets the elements for each fish id in an array, so that they're accessible throughout the controller.
  private handleMasks(): void {
    this.progress152 = [];
    this.progress151 = [];

    gameConstants.COLLECTION_IDS.forEach((id: number) => {
      const maskId = `${gameConstants.COLLECTION_MASKIDS[0]}${id}`;
      const mask = this.view.getShapeById(maskId);
      const progressId = `${gameConstants.COLLECTION_PROGRESS_IDS[0]}${id}`;
      const progress = this.view.getImageById(progressId);
      const countId = `${gameConstants.COLLECTION_COUNT_IDS[0]}${id}`;
      const counter = this.view.getMeterById(countId);
      const glowId = `${gameConstants.COLLECTION_GLOW_IDS[0]}${id}`;
      const glow = this.view.getSpineById(glowId);

      if (progress && mask) {
        this.progress151.push({
          id: id,
          mask: mask,
          progress: progress,
          counter: counter,
          glow: glow,
        });
      }
    });

    gameConstants.COLLECTION_IDS.forEach((id: any) => {
      const maskId = `${gameConstants.COLLECTION_MASKIDS[1]}${id}`;
      const mask = this.view.getShapeById(maskId);
      const progressId = `${gameConstants.COLLECTION_PROGRESS_IDS[1]}${id}`;
      const progress = this.view.getImageById(progressId);
      const countId = `${gameConstants.COLLECTION_COUNT_IDS[1]}${id}`;
      const counter = this.view.getMeterById(countId);
      const glowId = `${gameConstants.COLLECTION_GLOW_IDS[1]}${id}`;
      const glow = this.view.getSpineById(glowId);

      if (progress && mask) {
        this.progress152.push({
          id: id,
          mask: mask,
          progress: progress,
          counter: counter,
          glow: glow,
        });
      }
    });
  }

  //Sets the flow for the updation of masks and the position of loading glow based on the data from server, also using the array that we created earlier.
  private updateMasksFromData(): void {
    const meterData151 = (ingenuity.parserModel as GameParserModel).getCollectionMeter(gameConstants.RED_COLLECTION_ID);
    const meterData152 = (ingenuity.parserModel as GameParserModel).getCollectionMeter(
      gameConstants.GREEN_COLLECTION_ID
    );
    const meterMax151 = (ingenuity.parserModel as GameParserModel).getCollectionMeterMaxLimits(
      gameConstants.RED_COLLECTION_ID
    );
    const meterMax152 = (ingenuity.parserModel as GameParserModel).getCollectionMeterMaxLimits(
      gameConstants.GREEN_COLLECTION_ID
    );

    this.progress151.forEach((item) => {
      const symbolId = item.id;
      const currentValue = meterData151 ? (symbolId in meterData151 ? meterData151[symbolId] : 0) : 0;
      const maxValue = meterMax151[symbolId];
      const fillPercentage = Math.min(currentValue / maxValue, 1);

      if (currentValue !== 0) {
        this.view.getImageById(`${gameConstants.COLLECTION_BGGLOW_IDS[0]}${symbolId}`).visible = true;
        this.playFishSpines(gameConstants.RED_COLLECTION_ID, symbolId, true);
      } else {
        this.view.getImageById(`${gameConstants.COLLECTION_BGGLOW_IDS[0]}${symbolId}`).visible = false;
        this.playFishSpines(gameConstants.RED_COLLECTION_ID, symbolId, false);
      }
      this.updateMaskAndGlow(item.mask, item.glow, item.progress, fillPercentage);
      this.updateCounter(item.counter, currentValue, maxValue);
    });

    this.progress152.forEach((item) => {
      const symbolId = item.id;
      const currentValue = meterData152 ? (symbolId in meterData152 ? meterData152[symbolId] : 0) : 0;
      const maxValue = meterMax152[symbolId];
      const fillPercentage = Math.min(currentValue / maxValue, 1);

      if (currentValue !== 0) {
        this.view.getImageById(`${gameConstants.COLLECTION_BGGLOW_IDS[1]}${symbolId}`).visible = true;
        this.playFishSpines(gameConstants.GREEN_COLLECTION_ID, symbolId, true);
      } else {
        this.view.getImageById(`${gameConstants.COLLECTION_BGGLOW_IDS[1]}${symbolId}`).visible = false;
        this.playFishSpines(gameConstants.GREEN_COLLECTION_ID, symbolId, false);
      }
      this.updateMaskAndGlow(item.mask, item.glow, item.progress, fillPercentage);
      this.updateCounter(item.counter, currentValue, maxValue);
    });
  }

  //Responsible for updating the mask height, position and glow position for each individual fish.
  private updateMaskAndGlow(mask: Graphics, glow: SpineBase, progress: Bitmap, fill: number): void {
    const progressHeight = progress.height;
    const visibleHeight = progressHeight * fill;
    mask.x = -16;
    const bottomY = -70 + progressHeight;
    mask.y = bottomY - visibleHeight;
    mask.height = visibleHeight;
    progress.mask = mask;
    glow.visible = true;
    glow.setPause(false);
    glow.y = glow.json.y - visibleHeight;
    if (ingenuity.configData.isCollectionAfterHnR) {
      fill !== 0 ? glow.playAnim("move1", true) : (glow.visible = false);
    } else {
      fill !== 0 ? glow.playAnim("idle", true) : (glow.visible = false);
    }
  }

  //Updates the counter for each individual fish.
  private updateCounter(counter: Meter, currentVal: number, max: number) {
    counter.text = counter ? `${currentVal}/${max}` : `${0}/${max}`;
  }

  //Plays the animation in each individual fish, based on their values.
  private playFishSpines(collectionId: number, symbolId: number, win: boolean): void {
    const fishSpine = this.view.getSpineById(`${gameConstants.COLLECTION_FISH_ID}${collectionId}_${symbolId}`);
    const animId = this.model.getFishAnimId(collectionId, symbolId, win);
    fishSpine.visible = true;
    fishSpine.playAnim(animId, true);
  }

  //Tweens to the next page when the next page button is clicked.
  private onNextPagePressed(): void {
    (ingenuity.soundManager as AudioControllerBehavior).playSound(SoundConstant.COMMON_CLICK_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    this.collectionContainer_151.x = 2000;
    this.collectionContainer_151.visible = true;
    const page152Tween: ITween = ingenuity.currentGame.add.tween(this.collectionContainer_152);
    const page151Tween: ITween = ingenuity.currentGame.add.tween(this.collectionContainer_151);
    page152Tween.to({ x: -2000 }, 600, Exponential.InOut);
    page151Tween.to({ x: 0 }, 600, Exponential.InOut);
    page152Tween.start();
    page151Tween.start();
    page151Tween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.removeFrom(this);
      this.collectionContainer_152.visible = false;
    });
  }
  //Tweens to the previous page when the previous page button is clicked.
  private onPrevPagePressed(): void {
    (ingenuity.soundManager as AudioControllerBehavior).playSound(SoundConstant.COMMON_CLICK_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    this.collectionContainer_152.x = -2000;
    this.collectionContainer_152.visible = true;
    const page152Tween: ITween = ingenuity.currentGame.add.tween(this.collectionContainer_152);
    const page151Tween: ITween = ingenuity.currentGame.add.tween(this.collectionContainer_151);
    page151Tween.to({ x: 2000 }, 600, Exponential.InOut);
    page152Tween.to({ x: 0 }, 600, Exponential.InOut);
    page151Tween.start();
    page152Tween.start();
    page152Tween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.removeFrom(this);
      this.collectionContainer_151.visible = false;
    });
  }

  //Tweens the panel away from the screen when back button is clicked or collection presentation has ended.
  private tweenAwayPanel(): void {
    this.hideGameLogo();
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_AFTER_BIGWIN);
    const goUpTween: ITween = ingenuity.currentGame.add.tween(this.collectionMainContainer);
    goUpTween.to({ y: -2000 }, 600, Exponential.Out);
    goUpTween.start();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    goUpTween.onComplete.addOnce(() => {
      if (ingenuity.configData.isCollectionAfterHnR) {
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        ((ingenuity.parserModel as GameParserModel).getPromotionalFreeGame()) && dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, true);
      } else {
        dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
      }
      this.collectionMainContainer.visible = false;
      ingenuity.configData.isCollectionAfterHnR = false;
      ingenuity.currentGame.tweens.remove(goUpTween);
    }, this);
  }
  private hideGameLogo(): void {
    const fadeInTween = ingenuity.currentGame.add.tween(this.CollectionPanelgameLogo);
    fadeInTween.to({ alpha: 0 }, 600, Linear.None, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      this.CollectionPanelgameLogo.visible = false;
      this.CollectionPanelgameLogo.alpha = 1;
      fadeInTween.stop();
      ingenuity.currentGame.tweens.remove(fadeInTween);
    }, this);
  }
  //Sets the flow for when collection screen is hidden.
  private hideCollectionScreen(): void {
    (ingenuity.soundManager as AudioControllerBehavior).playSound(SoundConstant.COMMON_CLICK_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    this.tweenAwayPanel();
    this.collectionContainer_152.x = 0;
    this.collectionContainer_151.x = 0;
    this.resetPositions();
    this.handleCollectionButtonsInput(gameConstants.COLLECTION_BUTTONS_DISABLE);
  }

  //Resets the values of glows and stops their spines when collection screen is hidden.
  private resetPositions(): void {
    this.progress151.forEach((item) => {
      item.glow.visible = false;
      item.glow.setPause(true);
      item.glow.y = item.glow.json.y;
    });
    this.progress152.forEach((item) => {
      item.glow.visible = false;
      item.glow.setPause(true);
      item.glow.y = item.glow.json.y;
    });
  }

  //Sets the flow for the appearance of collection screen when bonus ends.
  private onRevealCollectionAfterHnR(): void {
    this.view.addViewToTop();
    ingenuity.configData.isCollectionAfterHnR = true;
    this.tweenDownPanel((ingenuity.parserModel as GameParserModel).getTriggeredBait());
  }

  //Animates all progress bars in case fishes are collected at the end of bonus. Also checks for wins and starts the flow for win if there's one.
  private animateAllProgressBars(collectionId: number): void {
    const currentValues: any = {};
    const progressObj = collectionId === 151 ? this.progress151 : this.progress152;

    progressObj.forEach((item) => {
      const symbolId = item.id;
      currentValues[symbolId] = item.counter ? parseInt(item.counter.text.split("/")[0]) : 0;
    });

    const newMeterData = (ingenuity.parserModel as GameParserModel).getCollectionMeterData(collectionId);
    const meterMax = (ingenuity.parserModel as GameParserModel).getCollectionMeterMaxLimits(collectionId);

    const pendingWins = this.checkForWin(collectionId);
    this.model.setPendingWins(pendingWins);
    progressObj.forEach((item) => {
      const symbolId = item.id;
      const startValue = currentValues[symbolId] || 0;
      const endValue = symbolId in newMeterData ? newMeterData[symbolId] : 0;
      const maxValue = meterMax[symbolId];

      if (endValue !== 0 && startValue < endValue) {
        startValue === 0
          ? (ingenuity.soundManager as any).playSound("fish_spawn_1", 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD)
          : (ingenuity.soundManager as any).playSound("count_refill", 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        this.animateProgressBar(item, startValue, endValue, maxValue, collectionId);
      } else if (endValue < startValue && startValue >= maxValue) {
        this.animateProgressBar(item, 0, endValue, maxValue, collectionId);
      }
    });
    collectionId === 151
      ? (ingenuity.parserModel as GameParserModel).setCollectionMeter151(newMeterData)
      : (ingenuity.parserModel as GameParserModel).setCollectionMeter152(newMeterData);

    if (pendingWins.length !== 0) {
      delayedCall("collectionWinDelay", 1000, () => {
        killDelayedCall("collectionWinDelay");
        dispatcher.fireEvent(eventDispatchers.SHOW_COLLECTION_WINS);
      });
    } else {
      delayedCall("TweenAwayDelay", 5000, this.tweenAwayPanel, this);
    }
  }

  //Responsible for animating progress bar for fishes one at a time.
  private animateProgressBar(
    item: any,
    startValue: number,
    endValue: number,
    maxValue: number,
    collectionId: number
  ): void {
    const bgGlowId =
      collectionId === 151 ? gameConstants.COLLECTION_BGGLOW_IDS[0] : gameConstants.COLLECTION_BGGLOW_IDS[1];
    const tweenObj = { value: startValue, percentage: (startValue > maxValue ? maxValue : startValue) / maxValue };
    const tweenDuration = 5000;
    const progressTween: ITween = ingenuity.currentGame.add.tween(tweenObj);
    progressTween.to(
      {
        value: endValue,
        percentage: Math.min(endValue / maxValue, 1),
      },
      tweenDuration,
      Exponential.Out
    );

    if (endValue - startValue !== 0) {
      this.view.getImageById(`${bgGlowId}${item.id}`).visible = true;
      this.playBlastSpines(collectionId, item.id);
      this.playFishSpines(collectionId, item.id, true);
    } else {
      this.view.getImageById(`${bgGlowId}${item.id}`).visible = false;
      this.playFishSpines(collectionId, item.id, false);
    }

    progressTween.onUpdateCallback(() => {
      this.updateMaskAndGlow(item.mask, item.glow, item.progress, tweenObj.percentage);
      this.updateCounter(item.counter, Math.ceil(tweenObj.value), maxValue);
    }, this);

    progressTween.start();

    progressTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(progressTween);
    }, this);
  }

  //Plays blast spines on counter and fish in case of collection.
  private playBlastSpines(collectionId: number, id: number): void {
    const countBlast = this.view.getSpineById(`counterEffect_${collectionId}_${id}`);
    const fishBlast = this.view.getSpineById(`fishBlast_${collectionId}_${id}`);
    countBlast.visible = true;
    countBlast.playAnim("animation", false);
    countBlast.onComplete.addOnce(() => {
      countBlast.visible = false;
    });
    fishBlast.visible = true;
    fishBlast.scale.set(0.4, 0.4);
    fishBlast.playAnim("fish_blast_effect1", false);
    fishBlast.onComplete.addOnce(() => {
      fishBlast.visible = false;
    });
  }

  //Enables or Disables buttons inside collection screen depending on whether the collection screen was opened by user or it was automatically shown after the feature ends.
  private handleCollectionButtonsInput(action: string): void {
    switch (action) {
      case gameConstants.COLLECTION_BUTTONS_ENABLE:
        (this.view.getButtonById("backBtn_152") as ButtonBase).enableAndTint();
        (this.view.getButtonById("backBtn_151") as ButtonBase).enableAndTint();
        (this.view.getButtonById("nextPageBtn") as ButtonBase).enableAndTint();
        (this.view.getButtonById("previousPageBtn") as ButtonBase).enableAndTint();
        break;
      case gameConstants.COLLECTION_BUTTONS_DISABLE:
        (this.view.getButtonById("backBtn_152") as ButtonBase).disableAndTint();
        (this.view.getButtonById("backBtn_151") as ButtonBase).disableAndTint();
        (this.view.getButtonById("nextPageBtn") as ButtonBase).disableAndTint();
        (this.view.getButtonById("previousPageBtn") as ButtonBase).disableAndTint();
        break;
    }
  }
  //Depending on the data from the server checks for wins in each individual collection.
  private checkForWin(collectionId:number): string[] {
    const wins: string[] = [];
    let collectionAward :any = (ingenuity.parserModel as GameParserModel).getMetersAwarded(collectionId);
    gameConstants.COLLECTION_LEVELS_SERVER_ID.forEach((id:string,index:number)=>{
        if(collectionAward[id]){
          wins.push(gameConstants.COLLECTION_LEVELS_GAME[index])
        }
    })
    return wins;
  }

  //In case of collection win starts the bubble glow spine animation.
  private onShowBubbleGlow(): void {
    const spineId = `${this.model.getCurrentWin()}BubbleEffect_${(ingenuity.parserModel as GameParserModel).getTriggeredBait()}`;
    const bubbleGlowSpine = this.view.getSpineById(spineId);
    const animationName = this.model.getCurrentWin() === "master" ? "master_meter" : "new_bie_and_expereinced_meters";
    bubbleGlowSpine.visible = true;
    bubbleGlowSpine.setPause(false);
    (ingenuity.soundManager as any).playSound("cashback_win", 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    bubbleGlowSpine.playAnim(animationName, true);
    delayedCall(
      "bubbleDelay",
      2000,
      () => {
        killDelayedCall("bubbleDelay");
        bubbleGlowSpine.visible = false;
        bubbleGlowSpine.setPause(true);
        dispatcher.fireEvent(eventDispatchers.SHOW_BANNER_WIN);
      },
      this
    );
  }

  //After the collection win banner is shown, resets the values for both the fish in the collection to 0.
  private onResetProgressAfterWin(evt: IEvent): void {
    const collectionName = evt.data;
    const collectionId = (ingenuity.parserModel as GameParserModel).getTriggeredBait();
    const collection = collectionId === 151 ? this.progress151 : this.progress152;
    const updatedMeterData = (ingenuity.parserModel as GameParserModel).getCollectionMeter(collectionId);
    const meterMax = (ingenuity.parserModel as GameParserModel).getCollectionMeterMaxLimits(collectionId);
    updatedMeterData[gameConstants.COLLECTION_LEVELS_SERVER_ID[gameConstants.COLLECTION_LEVELS_GAME.indexOf(collectionName)]]= 0;

    gameConstants.COLLECTION_PAIRS[collectionName].forEach((id: number) => {
      for (let i = 0; i < collection.length; i++) {
        const item = collection[i];
        if (item.id === id) {
          const symbolId = item.id;
          updatedMeterData[symbolId] = 0;
          const maxValue = meterMax[symbolId];
          this.view.getImageById(`${gameConstants.COLLECTION_BGGLOW_IDS[1]}${symbolId}`).visible = false;
          this.playFishSpines(collectionId, symbolId, false);
          this.updateMaskAndGlow(item.mask, item.glow, item.progress, 0);
          this.updateCounter(item.counter, 0, maxValue);
        } else {
          continue;
        }
      }
    });
    this.updateWinAmount(collectionId)
    collectionId === 151
      ? (ingenuity.parserModel as GameParserModel).setCollectionMeter151(updatedMeterData)
      : (ingenuity.parserModel as GameParserModel).setCollectionMeter152(updatedMeterData);
  }
}
